// Imports => React
import { useEffect } from 'react';

// Imports => Atoms
import {
  AcEmptyBlock,

} from '@opp/ui-kit';
import {withTranslation} from "react-i18next";
import {AcReportError} from "../../api/reporting.api";
import {observer} from "mobx-react-lite";
import {withStore} from "../../stores";

const AcDefaultError = ({ store: { api }, error, component, t }) => {
  useEffect(() => {
    error.component = component;
    error.location = window.location.href;
    api.reporting.report(error);
  }, [error]);

  return (
    <AcEmptyBlock message={t('something-went-wrong', {ns: 'common'})} />
  );
};

export default withTranslation(['common'])(withStore(observer(AcDefaultError)));
